import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { createInvestigation } from "../../../_redux/investigations/investigationsActions";
import { Modal } from "react-bootstrap";
import { InvoiceCreateForm } from "../../../../Accounting/Pages/invoices/invoice-create-modal/InvoiceCreateForm";
import { InvestigationCreateForm } from "./InvestigationCreateForm";
import { toast } from "react-hot-toast";

export function InvestigationCreateModal({ show, onHide }) {
  const btnRef = useRef();

  const dispatch = useDispatch();

  const onCreateClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const onCreateInvestigation = (investigation) => {
    dispatch(createInvestigation(investigation))
      .then(() => {
        onHide();
        toast.success("بازرسی با موفقیت ایجاد شد");
      })
      .catch(() => {
        toast.error("خطا هنگام ایجاد بازرسی");
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>ایجاد بازرسی جدید</Modal.Title>
      </Modal.Header>
      <Modal.Body></Modal.Body>
      <InvestigationCreateForm
        btnRef={btnRef}
        createInvestigation={onCreateInvestigation}
      />
      <Modal.Footer>
        <div>
          <button
            type={"button"}
            onClick={onHide}
            className={"btn btn-light btn-elevate"}
          >
            لغو
          </button>
          <> </>
          <button
            type={"button"}
            onClick={onCreateClick}
            className={"btn btn-primary btn-elevate"}
          >
            ایجاد بازرسی
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
